export default "__VITE_ASSET__COycl9fi__"